import { config } from './axios';
import { getConfigDetails } from './Config'

export const ApiConfig = {
    timeZone: 'America/New_York',
    defaultBookingLength: 24,
    clientSecret: getConfigDetails().clientSecret,
    encryptKey: 'Tw5qNOJLe5GFe7rjFsentNNQBsRHstbNzTP/18lkjnY=',
    getPassesReqUrl: config.baseURL + '/rate-pass',
    getUserPassesReqUrl: config.baseURL + '/user-passes',
    getPartnerDetailsReqUrl: config.baseURL + '/partners-key-by-secret',
    paymentReqUrl: config.baseURL + '/reservation',
    verifyMemberReqUrl: config.baseURL + '/verify-member-user',
    getGaragePriceUrl: config.baseURL + '/rate/facility-on-marker',
    eventLogUrl: config.baseURL + '/addUserEvent',
    getPaymentSessionUrl: config.baseURL + '/atlanta-planet-payment-session',
    getReservationUrl: config.baseURL + '/atlanta-reservation',
	// getBeforePayment: `${config.baseURL}/atlanta-booking-before-payment`,
    getChecksUrl: `${config.baseURL}/check-booking-before-payment`,
	getAfterPayment: `${config.baseURL}/aaa-booking-after-payment`,



    timeDropDown: [
        { value: "00:00:00", time: "12:00 AM" }, { value: "00:30:00", time: "12:30 AM" },
        { value: "01:00:00", time: "01:00 AM" }, { value: "01:30:00", time: "01:30 AM" },
        { value: "02:00:00", time: "02:00 AM" }, { value: "02:30:00", time: "02:30 AM" },
        { value: "03:00:00", time: "03:00 AM" }, { value: "03:30:00", time: "03:30 AM" },
        { value: "04:00:00", time: "04:00 AM" }, { value: "04:30:00", time: "04:30 AM" },
        { value: "05:00:00", time: "05:00 AM" }, { value: "05:30:00", time: "05:30 AM" },
        { value: "06:00:00", time: "06:00 AM" }, { value: "06:30:00", time: "06:30 AM" },
        { value: "07:00:00", time: "07:00 AM" }, { value: "07:30:00", time: "07:30 AM" },
        { value: "08:00:00", time: "08:00 AM" }, { value: "08:30:00", time: "08:30 AM" },
        { value: "09:00:00", time: "09:00 AM" }, { value: "09:30:00", time: "09:30 AM" },
        { value: "10:00:00", time: "10:00 AM" }, { value: "10:30:00", time: "10:30 AM" },
        { value: "11:00:00", time: "11:00 AM" }, { value: "11:30:00", time: "11:30 AM" },
        { value: "12:00:00", time: "12:00 PM" }, { value: "12:30:00", time: "12:30 PM" },
        { value: "13:00:00", time: "01:00 PM" }, { value: "13:30:00", time: "01:30 PM" },
        { value: "14:00:00", time: "02:00 PM" }, { value: "14:30:00", time: "02:30 PM" },
        { value: "15:00:00", time: "03:00 PM" }, { value: "15:30:00", time: "03:30 PM" },
        { value: "16:00:00", time: "04:00 PM" }, { value: "16:30:00", time: "04:30 PM" },
        { value: "17:00:00", time: "05:00 PM" }, { value: "17:30:00", time: "05:30 PM" },
        { value: "18:00:00", time: "06:00 PM" }, { value: "18:30:00", time: "06:30 PM" },
        { value: "19:00:00", time: "07:00 PM" }, { value: "19:30:00", time: "07:30 PM" },
        { value: "20:00:00", time: "08:00 PM" }, { value: "20:30:00", time: "08:30 PM" },
        { value: "21:00:00", time: "09:00 PM" }, { value: "21:30:00", time: "09:30 PM" },
        { value: "22:00:00", time: "10:00 PM" }, { value: "22:30:00", time: "10:30 PM" },
        { value: "23:00:00", time: "11:00 PM" }, { value: "23:30:00", time: "11:30 PM" }
    ]
}